// removed by extract-text-webpack-plugin
module.exports = {"button":"general__button___1ugJt cursor-pointer display-inlineBlock fontSize-s position-relative transitionDuration-l transitionProperty-all transitionTimingFunction-cb--scaleOut","iconWrap":"general__iconWrap___1ynVs pinTL position-absolute","icon":"general__icon___jL08a pinCenter position-absolute","isDisabled":"general__isDisabled___1JLrl pointerEvents-none","isOpaque":"general__isOpaque___2H609 opacity-40"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-toolbar/ToolbarButton/style/general.css
// module id = 255
// module chunks = 0 13